import { render, staticRenderFns } from "./ExtendedMultiXChart.vue?vue&type=template&id=1338b05c&scoped=true"
import script from "./ExtendedMultiXChart.vue?vue&type=script&lang=ts"
export * from "./ExtendedMultiXChart.vue?vue&type=script&lang=ts"
import style0 from "./ExtendedMultiXChart.vue?vue&type=style&index=0&id=1338b05c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338b05c",
  null
  
)

export default component.exports